import React from 'react';
import api from '../../../services/api';
import UploaderImage from '../../../components/UploaderImage';
import { Modal, toaster, Message, Button, Row, Col } from 'rsuite';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { IMAGES_PATH } from '../../../utils/imagesPath';

const GaleriaImagens = ({
  modal,
  fecharModal,
  idEmpresa,
  itemEdit,
  setProdutos,
}) => {
  const { theme } = useCustomTheme();
  const erase = async (colunaImagem) => {
    const fd = new FormData();
    fd.append('IdEmpresa', idEmpresa);
    fd.append('ColunaImagem', colunaImagem);
    fd.append('Id', itemEdit.Id);
    await api.post('produto/excluirFoto', fd).then((res) => {
      toaster.push(
        <Message showIcon type="success">
          A imagem foi apagada!
        </Message>,
      );

      if ((colunaImagem = 'Imagem')) {
        alterImageState(res.data, '');
      }
    });
  };

  const save = async (imagem, numberImage) => {
    const imageSizeMB = imagem.size / 1024 / 1024;
    if (imageSizeMB > 1) {
      toaster.push(
        <Message showIcon type="error">
          Imagem com tamanho maior que o permitido!
        </Message>,
      );
      return;
    }

    const fd = new FormData();
    fd.append('IdEmpresa', idEmpresa);
    fd.append('Id', itemEdit.Id);
    fd.append(`image${numberImage}`, imagem);
    await api.post('produto/alterarFoto', fd).then((res) => {
      toaster.push(
        <Message showIcon type="success">
          Upload de imagem concluido!
        </Message>,
      );
      if (numberImage === '') {
        alterImageState(res.data, imagem);
      }
    });
  };

  const alterImageState = (data, imagem) => {
    setProdutos((state) =>
      state.map((e) => {
        if (e.Id !== data.Id) {
          return e;
        }
        data.Imagem = imagem ? URL.createObjectURL(imagem) : '';
        data.altered = true;
        return data;
      }),
    );
  };

  const saveImage1 = async (imagem) => save(imagem, '');
  const saveImage2 = async (imagem) => save(imagem, 2);
  const saveImage3 = async (imagem) => save(imagem, 3);
  const saveImage4 = async (imagem) => save(imagem, 4);

  const deleteImage1 = async () => erase('Imagem');
  const deleteImage2 = async () => erase('Imagem2');
  const deleteImage3 = async () => erase('Imagem3');
  const deleteImage4 = async () => erase('Imagem4');

  const labelStyle = {
    fontWeight: 'bold',
    color: theme.colors.textSecondary,
  };

  return (
    <Modal
      backdrop={'static'}
      keyboard={false}
      open={modal}
      onClose={fecharModal}
      size={'lg'}
    >
      <Modal.Header>
        <Modal.Title>Galeria de Imagens</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '10px' }}>
        <h3 style={{ color: theme.colors.text }}>
          Fotos de {itemEdit.Descricao}
        </h3>
        <br />
        <Row>
          <Col md={6} sm={12}>
            <label style={labelStyle}>Imagem 1</label>
            <UploaderImage
              urlImage={itemEdit.Imagem ? `${IMAGES_PATH}${itemEdit.Imagem}` : null}
              saveMethod={saveImage1}
              deleteMethod={() => deleteImage1()}
            />
          </Col>
          <Col md={6} sm={12}>
            <label style={labelStyle}>Imagem 2</label>
            <UploaderImage
              urlImage={
                itemEdit.Imagem2 ? `${IMAGES_PATH}${itemEdit.Imagem2}` : null
              }
              saveMethod={saveImage2}
              deleteMethod={() => deleteImage2()}
            />
          </Col>
          <Col md={6} sm={12}>
            <label style={labelStyle}>Imagem 3</label>
            <UploaderImage
              urlImage={
                itemEdit.Imagem3 ? `${IMAGES_PATH}${itemEdit.Imagem3}` : null
              }
              saveMethod={saveImage3}
              deleteMethod={() => deleteImage3()}
            />
          </Col>
          <Col md={6} sm={12}>
            <label style={labelStyle}>Imagem 4</label>
            <UploaderImage
              urlImage={
                itemEdit.Imagem4 ? `${IMAGES_PATH}${itemEdit.Imagem4}` : null
              }
              saveMethod={saveImage4}
              deleteMethod={() => deleteImage4()}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={fecharModal}
          appearance="subtle"
          style={{ marginRight: 29, marginTop: 20 }}
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GaleriaImagens;
